import { NotificationService } from './services/notification.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiService } from './services';

import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { AuthSessionInterceptor } from './interceptors/auth-session.interceptor';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { usernameValidatorDirective } from './validation/matchUsername.validator';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs-v2';

@NgModule({
  declarations: [usernameValidatorDirective],
  imports: [CommonModule, NgxLinkifyjsModule],
  exports: [usernameValidatorDirective],
})
export class CoreModule {
  /**
   * Keep HTTP and service providers in the root injector. Lazy feature
   * modules import CoreModule for its shared directive only; importing
   * HttpClientModule there would create another interceptor chain without the
   * in-memory auth session.
   */
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ApiService,
        NotificationService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoaderInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthSessionInterceptor,
          multi: true,
        },
      ],
    };
  }
}
